import { createTheme } from '@mui/material'
import { green } from '@mui/material/colors'

const lightTheme = createTheme({
  components: {
    MuiFormLabel: {
      defaultProps: {
        sx: {
          '& .MuiFormLabel-asterisk': {
            color: '#D13E43',
            fontSize: '20px',
          },
        },
      },
    },
  },
  typography: {
    fontFamily:
      'Lato, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
  },

  palette: {
    mode: 'light',
    primary: {
      main: '#D13E43',
      dark: '#A83438',
    },
    secondary: {
      main: green[500],
    },
    text: {
      primary: '#4F4848',
      secondary: '#292D32',
    },
    customGrey: {
      one: '#F4F4F4',
      two: '#EAEAEA',
      three: '#CFCFCF',
      four: '#BFBFBF',
      five: '#F9F9F9',
    },
    error: {
      main: '#e74c3c',
      dark: '#db3b3b',
    },
    custom: {
      inputChanged: '#f6f2e0',
      link: '#0051FF',
      black: '#000000',
      white: '#ffffff',
    },
  },
})

export { lightTheme }
